import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable, EventEmitter } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DealsService {
  private directcall: HttpClient;
  dealData: any = null;
  dealData$: EventEmitter<any> = new EventEmitter<any>();
  constructor(protected httpClient: HttpClient, httpBackend: HttpBackend) {
    this.directcall = new HttpClient(httpBackend);
  }

  getDeals(agentId: String) {
    return this.httpClient.get(`/agent/${agentId}/deals`).pipe(
      map((body: any) => {
        return body;
      })
    );
  }

  getAllDeals(userId: String) {
    return this.httpClient.get(`/agent/${userId}/alldeals`).pipe(
      map((body: any) => {
        return body;
      })
    );
  }

  getAnalyticsDealData(userId: String) {
    let params = null;
    return this.httpClient.get(`/deal/${userId}/analytics`, { params }).pipe(
      map((body: any) => {
        return body;
      })
    );
  }  

  getDealById(agentId: string, dealId: string) {
    this.httpClient
      .get(`/agent/${agentId}/deal/${dealId}`)
      .subscribe((body: any) => {
        if (body) {
          this.dealData = body.records;
          this.dealData$.emit(this.dealData);
        } else {
          this.dealData = null;
        }
      });
  }

  getDealDataUpdateById(agentId: string, dealId: string) {
    return this.httpClient.get(`/agent/${agentId}/deal/${dealId}`).pipe(
      map((body: any) => {
        if (body) {
          this.dealData = body.records;
        } else {
          this.dealData = null;
        }
        return body;
      })
    );
  }

  getDealDataById(agentId: string, dealId: string) {
    return this.httpClient.get(`/agent/${agentId}/deal/${dealId}`).pipe(
      map((body: any) => {
        return body;
      })
    );
  }

  getDealDataDetails(agentId: string, dealId: string) {
    return this.httpClient.get(`/agent/${agentId}/dealview/${dealId}`).pipe(
      map((body: any) => {
        return body;
      })
    );
  }

  getDealsByFilter(agentId: String, payload: any) {
    return this.httpClient
      .post(`/agent/${agentId}/dealsbyfilter`, payload)
      .pipe(
        map((body: any) => {
          return body;
        })
      );
  }

  deleteDeal(agentId: String, dealId: string) {
    return this.httpClient.delete(`/agent/${agentId}/deal/${dealId}`).pipe(
      map((body: any) => {
        return body;
      })
    );
  }

  buildDeal(agentId: String, dealId: string, payload: any) {
    return this.httpClient
      .put(`/agent/${agentId}/deal/${dealId}/builddeal`, payload)
      .pipe(
        map((body: any) => {
          return body;
        })
      );
  }

  acceptRequest(agentId: String, dealId: string, payload: any) {
    return this.httpClient
      .put(`/agent/${agentId}/deal/${dealId}/acceptrequest`, payload)
      .pipe(
        map((body: any) => {
          return body;
        })
      );
  }

  dealInfo(dealId: string) {
    return this.httpClient
      .get(`/deal/${dealId}`)
      .pipe(
        map((body: any) => {
          return body;
        })
      );
  }
  
  dealDataInfo(dealId: string) {
    return this.httpClient
      .get(`/dealdata/${dealId}`)
      .pipe(
        map((body: any) => {
          return body;
        })
      );
  }

  rejectRequest(agentId: String, dealId: string, payload: any) {
    return this.httpClient
      .put(`/agent/${agentId}/deal/${dealId}/rejectrequest`, payload)
      .pipe(
        map((body: any) => {
          return body;
        })
      );
  }

  stepSubmit(userId: String, stepNo: any, payload: any, isAddMode?: boolean) {
    if (stepNo === 1 && isAddMode) {
      return this.httpClient
        .post(`/agent/${userId}/deal/step${stepNo}`, payload)
        .pipe(
          map((body: any) => {
            return body;
          })
        );
    } else {
      return this.httpClient
        .put(`/agent/${userId}/deal/step${stepNo}`, payload)
        .pipe(
          map((body: any) => {
            return body;
          })
        );
    }
  }

  updateAency(dealId: any, payload: any){
    return this.httpClient.post(`/deal/${dealId}/updatedealagency`, payload).pipe(
      map((body: any) => {
        return body;
      })
    );
  }

  changeRequest(dealId: any, payload: any) {
    return this.httpClient.post(`/deal/${dealId}/changerequest`, payload).pipe(
      map((body: any) => {
        return body;
      })
    );
  }

  getProductsByCategory(catName: string) {
    return this.httpClient.get(`/productlist/${catName}`).pipe(
      map((body: any) => {
        return body;
      })
    );
  }

  getProductsarray(catName: string) {
    return this.httpClient.get(`/productlist/${catName}`).pipe(
      map((body: any) => {
        return body;
      })
    );
  }

  getCustomProductsList(payload: any) {
    return this.httpClient.post(`/productlist/custom`, payload).pipe(
      map((body: any) => {
        return body;
      })
    );
  }

  getCustomProductsExport(payload: any) {
    return this.httpClient.get(`/productlist/export`).pipe(
      map((body: any) => {
        return body;
      })
    );
  }

  submitCustomProduct(payload: any,productId:string) {
    if(productId){
      return this.httpClient.put(`/productlist/submitcustom/${productId}`, payload).pipe(
        map((body: any) => {
          return body;
        })
      );
    } else {
      return this.httpClient.post(`/productlist/submitcustom`, payload).pipe(
        map((body: any) => {
          return body;
        })
      );
    }
  }
  removeCustomProduct(productId:string) {   
      return this.httpClient.delete(`/productlist/submitcustom/${productId}`).pipe(
        map((body: any) => {
          return body;
        })
      );
  }

  getLendersList() {
    return this.httpClient.get(`/lenderslist`).pipe(
      map((body: any) => {
        return body;
      })
    );
  }

  getDealSelectedProducts(agentId: string, dealId: string) {
    return this.httpClient
      .get(`/agent/${agentId}/deal/${dealId}/selectedproduct`)
      .pipe(
        map((body: any) => {
          return body;
        })
      );
  }

  getchangeRequestData(dealId: any, chageRequestId: any) {
    return this.httpClient
      .get(`/deal/${dealId}/changerequest/${chageRequestId}`)
      .pipe(
        map((body: any) => {
          return body;
        })
      );
  }

  mergeChangeRequest(dealId: any, chageRequestId: any) {
    return this.httpClient
      .put(`/deal/${dealId}/changerequest/${chageRequestId}/merge`, {})
      .pipe(
        map((body: any) => {
          return body;
        })
      );
  }

  rejectChangeRequest(dealId: any, chageRequestId: any, payload: any) {
    return this.httpClient
      .put(`/deal/${dealId}/changerequest/${chageRequestId}/reject`, payload)
      .pipe(
        map((body: any) => {
          return body;
        })
      );
  }

  getChangeRequestList(dealId: any) {
    return this.httpClient.get(`/deal/${dealId}/changerequestlist`).pipe(
      map((body: any) => {
        return body;
      })
    );
  }

  helprequest(helpFormdata: any) {
    return this.httpClient.put(`/deal/helprequest`, helpFormdata).pipe(
      map((body: any) => {
        return body;
      })
    );
  }
  changeStatus(dealId: string, payload: any) {
    return this.httpClient.put(`/deal/${dealId}/changestatus`, payload).pipe(
      map((body: any) => {
        return body;
      })
    );
  }

  refreshPDF(data: any) {
    let payload = JSON.parse(data);
    return this.httpClient.post(`/deal/${payload[0]}/refreshpdf`, payload[1]).pipe(
      map((body: any) => {
        return body;
      })
    );
  }

  sharePDF(dealId: string, payload: any) {
    return this.httpClient.post(`/deal/${dealId}/sharepdf`, payload).pipe(
      map((body: any) => {
        return body;
      })
    );
  }

  resendPDF(dealId: string, payload: any) {
    return this.httpClient.post(`/deal/${dealId}/resendpdf`, payload).pipe(
      map((body: any) => {
        return body;
      })
    );
  }

  updatePDF(payload: any) {
    return this.httpClient.post(`/deal/updatepdf`, payload).pipe(
      map((body: any) => {
        return body;
      })
    );
  }

  sendIncentivePDF(dealId: string, payload: any) {
    return this.httpClient.post(`/deal/${dealId}/sendIncentivepdf`, payload).pipe(
      map((body: any) => {
        return body;
      })
    );
  }
  
  sendPDF(dealId: string, payload: any) {
    return this.httpClient.post(`/deal/${dealId}/sendpdf`, payload).pipe(
      map((body: any) => {
        return body;
      })
    );
  }

  sendComPDF(dealId: string, payload: any) {
    return this.httpClient.post(`/deal/${dealId}/sendCompdf`, payload).pipe(
      map((body: any) => {
        return body;
      })
    );
  }

  counterSignComPDF(dealId: string, payload: any) {
    return this.httpClient.post(`/deal/${dealId}/counterSignCompdf`, payload).pipe(
      map((body: any) => {
        return body;
      })
    );
  }

  getMailList(dealId: string) {
    return this.httpClient.get(`/deal/${dealId}/mailhistory`).pipe(
      map((body: any) => {
        return body;
      })
    );
  }

  getSingedURL(url: string) {
    let payload={url:url}
    return this.httpClient.post(`/deal/getsignurl`, payload).pipe(
      map((body: any) => {
        return body;
      })
    );
  }

  getZipDetails(zip: number) {
    let payload={zip_code: zip}
    return this.directcall
    .post(`${environment.devServiceURL}/zip/basics/zipCodes`, payload)
    .pipe(
      map((body: any) => {
        return body;
      })
    );
  }
}
